import React from "react";
import TitleInput from "./TitleInput";
import Todo from "./Todo";

const CombinedTodo = (props) => {
  const { showInput, editId } = props.editTitle;
  const { id } = props.todo;
  return showInput && id === editId ? <TitleInput {...props} /> : <Todo {...props} />;
};

export default CombinedTodo;
